import { render, staticRenderFns } from "./MDMulty.vue?vue&type=template&id=794f2acb"
import script from "./MDMulty.vue?vue&type=script&lang=js"
export * from "./MDMulty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports